import React from 'react'

import TransactionForm from '../TransactionForm'
import { TransactionType } from '../../../../graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type CreatePartsTransferFormProps = {
	onCancel: () => void,
	onSuccess: () => void,
}

export default function CreatePartsTransferForm( props: CreatePartsTransferFormProps ) {
	const onCancelClick = () => {
		heapEvent( 'Inventory - Transfer Parts Modal - Click - Cancel', {} )
		props.onCancel()
	}
	const onSubmitClick = () => heapEvent( 'Inventory - Transfer Parts Modal - Click - Submit', {} )
	return (
		<TransactionForm
			transactionType={TransactionType.StoreToStore}
			{...props}
			onCancel={onCancelClick}
			onSubmitClick={onSubmitClick}
		/>
	)
}
